import resumePdf from "../assets/dagm-cv";

const getTime = () => {
  const date = new Date();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  return `${hours}${minutes < 10 ? ":0" : ":"}${minutes}${seconds < 10 ? ":0" : ":"}${seconds}`;
};

const introduction = [
  {
    type: "hero",
    content:
      "Welcome. I build production React Native fintech and e-commerce apps. Type `guide`, `projects`, `case-studies`, `experience`, or `gui`.",
  },
  {
    type: "system",
    label: "System",
    content:
      "Try `about`, `experience`, `projects`, `skills`, `hire`, `contact`, or `help` to get started.",
  },
  {
    type: "system",
    label: "System",
    content: "Thanks for your visit, let me introduce myself.",
  },
  {
    time: getTime(),
    type: "info",
    label: "Name:",
    content: "Dagm Ayalew",
  },
  {
    time: getTime(),
    type: "info",
    label: "Role:",
    content: "Mobile App Developer",
  },
  {
    time: getTime(),
    type: "info",
    label: "Location:",
    content: "Addis Ababa, Ethiopia",
  },
  {
    time: getTime(),
    type: "info",
    label: "Phone:",
    content: "+251988280976",
  },
  {
    time: getTime(),
    type: "info",
    label: "Email:",
    content: "dagmayalew489@gmail.com",
  },
];

const openLink = (print, url, statusText = "Opening", sameTab = false) =>
  new Promise((resolve) => {
    print({ type: "success", label: "Success", content: statusText });

    if (sameTab) {
      window.location.assign(url);
    } else {
      window.open(url, "_blank");
    }

    resolve({ type: "success", label: "Done", content: "Opened!" });
  });

const openPdf = (print, dataUrl, fileName = "dagm-cv.pdf") =>
  new Promise((resolve) => {
    print({ type: "success", label: "Success", content: "Opening resume" });

    const base64 = dataUrl.split(",")[1];
    const binary = window.atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = blobUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.setTimeout(() => {
      window.URL.revokeObjectURL(blobUrl);
    }, 60 * 1000);

    resolve({ type: "success", label: "Done", content: "Resume opened!" });
  });

export default {
  intro: {
    description: "Introduce Dagm and show a quick getting-started message.",
    run(print) {
      let i = 0;
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          print(introduction[i]);
          i++;
          if (!introduction[i]) {
            clearInterval(interval);
            resolve({
              type: "success",
              label: "Done",
              content: "Introduction complete.",
            });
          }
        }, 500);
      });
    },
  },
  open: {
    description: "Open any URL in a new tab.",
    aliasList: ["visit"],
    run(print, input) {
      return new Promise((resolve) => {
        if (!input) {
          resolve({
            type: "error",
            label: "Error",
            content: "a url is required!",
          });
          return;
        }
        if (!input.startsWith("http")) {
          resolve({
            type: "error",
            label: "Error",
            content: "Please add `http` prefix!",
          });
          return;
        }
        print({ type: "success", label: "Success", content: "Opening" });

        window.open(input, "_blank");
        resolve({ type: "success", label: "Done", content: "Page Opened!" });
      });
    },
  },
  gui: {
    description: "Open the visual version of my portfolio.",
    aliasList: ["site", "home"],
    run(print) {
      return openLink(
        print,
        "https://www.dagmayalew.online/",
        "Navigating",
        true,
      );
    },
  },
  github: {
    description: "Open my GitHub profile in a new tab.",
    aliasList: ["gh", "source", "code"],
    run(print) {
      return openLink(print, "https://github.com/Dagmayalew");
    },
  },
  linkedin: {
    description: "Open my LinkedIn profile in a new tab.",
    aliasList: ["in"],
    run(print) {
      return openLink(print, "https://www.linkedin.com/in/dagm-ayalew/");
    },
  },
  resume: {
    description: "Open my 2026 CV PDF.",
    aliasList: ["cv", "download", "pdf"],
    run(print) {
      return openPdf(print, resumePdf);
    },
  },
  email: {
    description: "Open your email app to contact me directly.",
    aliasList: ["mail"],
    run(print) {
      return openLink(
        print,
        "mailto:dagmayalew489@gmail.com?subject=Hello%20Dagm",
        "Opening email",
        true,
      );
    },
  },
};
